// start:ng42.barrel
import './transport-dashboard.component';
// end:ng42.barrel

